import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree, projectFour,projectEleven, magiceden, projectFive, projectSix, projectSeven, projecteight, nine, projectTen } from "../../assets/index";
import ProjectsCard from './ProjectsCard';
import { Link } from 'react-router-dom';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="MERN STACK Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-14">
        <Link to='https://www.alamkitab.com/' target='_blank'><ProjectsCard
          title="Ecommerce Website (Pakistan)"
          des="AlamKitab is an online platform offering a diverse collection of books with secure purchasing and convenient delivery."
          src={projectSix}
        /></Link>
        <Link to='https://studycato.onrender.com/' target='_blank'><ProjectsCard
          title="Ecommerce Website"
          des="My cutting-edge e-commerce platform utilizes React.js, Node.js, MongoDB, Material-UI, Bootstrap, Tailwind CSS, Python, and PayPal integration for seamless shopping experiences and merchant management."
          src={projectOne}
        /></Link>
         <Link to='https://blogging-app-wahaj.web.app/login' target='_blank'><ProjectsCard
          title="Blogging Website"
          des="My innovative blogging website offers intuitive interfaces, responsive design, and secure content management, empowering users to share their ideas effectively."
          src={projectTwo}
        /></Link>
        <Link to='https://school-management-wahaj.web.app' target='_blank'><ProjectsCard
          title="School Management Website"
          des="MERN Stack Project | Admin login and password: hello@gmail.com | Admin can add/delete teacher, student, subjects, classes, send notices and take action on 
          students complain"
          src={projectFour}
        /></Link>
        <Link to='https://quran-web-wahaj.web.app/' target='_blank'><ProjectsCard
          title="Quran Website"
          des="My Quran website offers comprehensive access to the holy text, featuring intuitive navigation, translations, interpretations, and audio recitations for spiritual enrichment."
          src={projectFive}
        /></Link>
        <Link to='https://yosemite-grill.web.app/' target='_blank'><ProjectsCard
          title="Restaurant Website"
          des="My restaurant website showcases tantalizing menus, elegant ambiance, and convenient online reservations, providing an immersive experience for food enthusiasts and diners."
          src={projectSeven}
        /></Link>
        <Link to='https://zavia-management.web.app/' target='_blank'><ProjectsCard
          title="Tour & Travel Website"
          des="My travel and tour agency website showcases breathtaking destinations, curated travel packages, and seamless online bookings, providing an immersive experience for adventurers and explorers."
          src={projectTen}
        /></Link>
        <Link to='http://www.actonjets.com/' target='_blank'><ProjectsCard
          title="Acton Jets"
          des="Acton Jets is a premier private jet charter service offering luxury air travel with safety, comfort, and convenience."
          src={projectEleven}
        /></Link>
        <Link to='/' target='_blank'><ProjectsCard
          title="Attendence Website"
          des="Under Construction | MERN Stack Project"
          src={projectThree}
        /></Link>
        <Link to='/' target='_blank'><ProjectsCard
          title="Inventory Management System"
          des="Under Construction | MERN Stack Project"
          src={projecteight}
        /></Link>
        <Link to='https://magic-eden-wahaj.vercel.app/' target='_blank'><ProjectsCard
          title="Magic Eden Clone"
          des="A Magic Eden clone is a customizable NFT marketplace replica enabling seamless buying, selling, and trading of digital assets on blockchain networks."
          src={magiceden}
        /></Link>
        <Link to='/' target='_blank'><ProjectsCard
          title="Leave System Website (Employes)"
          des="Under Construction | MERN Stack Project"
          src={projecteight}
        /></Link>
        <Link to='/' target='_blank'><ProjectsCard
          title="Food Ordering Website"
          des="Under Construction | MERN Stack Project"
          src={nine}
        /></Link>
        
      </div>
      {/* <p className='text-center'>Remaining Projects will be shared here within 1 week. Some are under construction and 
          some are not deploying yet.
        </p> */}
    </section>
  );
}

export default Projects